import { render, staticRenderFns } from "./Demo.vue?vue&type=template&id=f6abf2c8&"
import script from "./Demo.vue?vue&type=script&lang=ts&"
export * from "./Demo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports